var _polygon, _rect, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _rect2, _rect3, _polygon8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPB2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 990 720"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.2.1",
    points: "271 373 366 373 366 383.95 393 383.95 393 535 271 535 271 373"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.2.2",
    x: 80.7,
    y: 373,
    width: 186.36,
    height: 162
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.2.3",
    points: "93 201 267 201 267 331.88 166 331.88 166 368 93 368 93 201"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.2.4",
    points: "271 188 393 188 393 331.88 298 331.88 298 321 271 321 271 188"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.2.5",
    points: "396.64 188 518.87 188 518.87 320.78 492 320.78 492 332 396.64 332 396.64 188"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.2.6",
    points: "523.3 188 645 188 645 332 550 332 550 321 523.3 321 523.3 188"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.2.7",
    points: "650 170 771 170 771 321 744 321 744 332 649 332 649 170 650 170"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.2.8",
    points: "775.32 170 911 170 911 303 898 303 898 368 775.32 368 775.32 170"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.2.9",
    x: 747,
    y: 373,
    width: 151,
    height: 131
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.2.10",
    x: 649,
    y: 373,
    width: 93,
    height: 131
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.2.11",
    points: "550.03 373 645 373 645 516 523 516 523 384.13 550 384.13 550.03 373"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5OTAgNzIwIj4KCgogICAgPHBvbHlnb24gZGF0YS1pZD0iQi4yLjEiIHBvaW50cz0iMjcxIDM3MyAzNjYgMzczIDM2NiAzODMuOTUgMzkzIDM4My45NSAzOTMgNTM1IDI3MSA1MzUgMjcxIDM3MyIvPgoKCiAgICA8cmVjdCBkYXRhLWlkPSJCLjIuMiIgeD0iODAuNyIgeT0iMzczIiB3aWR0aD0iMTg2LjM2IiBoZWlnaHQ9IjE2MiIvPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjIuMyIgcG9pbnRzPSI5MyAyMDEgMjY3IDIwMSAyNjcgMzMxLjg4IDE2NiAzMzEuODggMTY2IDM2OCA5MyAzNjggOTMgMjAxIi8+CgogICAgPHBvbHlnb24gZGF0YS1pZD0iQi4yLjQiIHBvaW50cz0iMjcxIDE4OCAzOTMgMTg4IDM5MyAzMzEuODggMjk4IDMzMS44OCAyOTggMzIxIDI3MSAzMjEgMjcxIDE4OCIvPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjIuNSIgcG9pbnRzPSIzOTYuNjQgMTg4IDUxOC44NyAxODggNTE4Ljg3IDMyMC43OCA0OTIgMzIwLjc4IDQ5MiAzMzIgMzk2LjY0IDMzMiAzOTYuNjQgMTg4Ii8+CgoKICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkIuMi42IiBwb2ludHM9IjUyMy4zIDE4OCA2NDUgMTg4IDY0NSAzMzIgNTUwIDMzMiA1NTAgMzIxIDUyMy4zIDMyMSA1MjMuMyAxODgiLz4KCgogICAgPHBvbHlnb24gZGF0YS1pZD0iQi4yLjciIHBvaW50cz0iNjUwIDE3MCA3NzEgMTcwIDc3MSAzMjEgNzQ0IDMyMSA3NDQgMzMyIDY0OSAzMzIgNjQ5IDE3MCA2NTAgMTcwIi8+CgoKICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkIuMi44IiBwb2ludHM9Ijc3NS4zMiAxNzAgOTExIDE3MCA5MTEgMzAzIDg5OCAzMDMgODk4IDM2OCA3NzUuMzIgMzY4IDc3NS4zMiAxNzAiLz4KCgogICAgPHJlY3QgZGF0YS1pZD0iQi4yLjkiIHg9Ijc0NyIgeT0iMzczIiB3aWR0aD0iMTUxIiBoZWlnaHQ9IjEzMSIvPgoKCiAgICA8cmVjdCBkYXRhLWlkPSJCLjIuMTAiIHg9IjY0OSIgeT0iMzczIiB3aWR0aD0iOTMiIGhlaWdodD0iMTMxIi8+CgoKICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkIuMi4xMSIgcG9pbnRzPSI1NTAuMDMgMzczIDY0NSAzNzMgNjQ1IDUxNiA1MjMgNTE2IDUyMyAzODQuMTMgNTUwIDM4NC4xMyA1NTAuMDMgMzczIi8+Cgo8L3N2Zz4=";
export { SvgPB2 as ReactComponent };